import { render, staticRenderFns } from "./productDemandList.vue?vue&type=template&id=f8f684da&"
import script from "./productDemandList.vue?vue&type=script&lang=js&"
export * from "./productDemandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports